import { Box, Tooltip } from "@mui/material";
import React from "react";
import Txt from "../typography/Txt";
import { grey } from "@mui/material/colors";
import { size } from "lodash";
import EnhancedCommentItemRenderer from "../../_src_shared/comments/EnhancedCommentItemRenderer";
import CommentsRenderer from "../renderers/CommentsRenderer";

const CommentThreadPreviewTooltip = ({
  loan,
  comments,
  children,
  enhanced = false,
  placement = "left",
}) => {

  const tooltipContent = (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        overflow: "hidden",
      }}
    >
      {enhanced ? (
        <>
          <Txt
            bold
            sx={{
              color: `${grey[700]} !important`,
              mb: 0.5,
            }}
          >
            Comments ({size(comments)})
          </Txt>
          <Box
            sx={{
              flexGrow: 1,
              overflowY: "auto",
              maxHeight: "min(540px, 75vh)",
              minWidth: "360px",
              maxWidth: "100%",
              borderRadius: 1.2,
              border: `1px solid ${grey[200]}`,
            }}
          >
            <EnhancedCommentItemRenderer
              sx={{ width: "100%" }}
              loan={loan}
              comments={comments}
            />
          </Box>
        </>
      ) : (
        <Box
          sx={{
            flexGrow: 1,
            overflowY: "auto",
            maxHeight: "640px",
            minWidth: "500px",
          }}
        >
          <CommentsRenderer sx={{ width: "100%" }} comments={comments} />
        </Box>
      )}
    </Box>
  );
  return (
    <Tooltip
      title={tooltipContent}
      placement={placement}
      disableInteractive={false}
      // Keep the (wide) preview inside the viewport: flip to the other side
      // and shift as needed so it never renders off-screen.
      PopperProps={{
        modifiers: [
          { name: "flip", enabled: true },
          {
            name: "preventOverflow",
            enabled: true,
            // altAxis keeps it from running off the top/bottom too (the
            // cross-axis when placed left/right).
            options: { boundary: "viewport", padding: 8, altAxis: true },
          },
        ],
      }}
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: "background.paper",
            color: "text.primary",
            boxShadow: "0px 4px 20px rgba(0,0,0,0.15)",
            borderRadius: "8px",
            border: `1px solid ${grey[200]}`,
            p: 1.5,
            // Cap the width so it can't span the screen; stays responsive.
            maxWidth: "min(90vw, 520px)",
          },
        },
        arrow: {
          sx: {
            color: "background.paper",
            "&::before": {
              border: `1px solid ${grey[200]}`,
            },
          },
        },
      }}
    >
      <Box>{children}</Box>
    </Tooltip>
  );
};

export default CommentThreadPreviewTooltip;
